import { Box } from '@ltvco/refresh-lib/theme';
import { SectionCard } from '../components';
import { TokenExSubscribe } from './TokenExSubscribe';

interface PaymentSectionProps {
  paymentMethod: string;
  setPaymentMethod: (method: string) => void;
  terms1: boolean;
  setTerms1: (checked: boolean) => void;
  terms2: boolean;
  setTerms2: (checked: boolean) => void;
  email: string;
  firstName: string;
  lastName: string;
  formErrors: any;
  createCardQuery: any;
  extendedImages: any;
  onProcessingStart?: () => void;
  onSuccess?: () => void;
  onError?: (errors?: string[]) => void;
  onPaymentMethodAdded?: () => void;
}

export const PaymentSection = ({
  paymentMethod,
  setPaymentMethod,
  terms1,
  setTerms1,
  terms2,
  setTerms2,
  email,
  firstName,
  lastName,
  formErrors,
  createCardQuery,
  extendedImages,
  onProcessingStart,
  onSuccess,
  onError,
  onPaymentMethodAdded,
}: PaymentSectionProps) => {
  return (
    <SectionCard variant="outlined" sx={{ p: { xs: 1, md: 3 }, mt: 3 }}>
      <TokenExSubscribe
        createCardQuery={createCardQuery}
        terms1={terms1}
        terms2={terms2}
        setTerms1={setTerms1}
        setTerms2={setTerms2}
        onProcessingStart={onProcessingStart}
        onSuccess={onSuccess}
        onError={onError}
        initialEmail={email}
        initialFirstName={firstName}
        initialLastName={lastName}
      />
    </SectionCard>
  );
};
